import {rpAppLink} from "@pg-mono/rp-routes";

import {RegionType} from "../../region/types/RegionType";

interface IRegion {
    name: string;
    short_name?: string;
    name_declension_what: string;
    slug: string;
    stats?: {
        region_type_city?: {
            slug?: string;
            name: string;
        } | null;
    } | null;
    type: RegionType;
}

type UrlReturnType = {
    url: string;
    label: string;
} | null;

export const getRegionDataForVendorListing = (region: IRegion, parentRegions: Omit<IRegion, "stats">[]): UrlReturnType => {
    // no region
    if (!region) {
        return null;
    }

    // voivodeship exception
    if (region.type === RegionType.VOIVODESHIP) {
        return {
            url: rpAppLink.vendor.listFriendly({
                friendlySlug: region.slug
            }),
            label: `z ${region.name_declension_what}`
        };
    }

    const regionForVendorListing = getRegionDataForVendorListingLink(region, parentRegions);
    if (!regionForVendorListing) {
        return null;
    }

    const label = getShouldUseCityData(region.type) ? regionForVendorListing.name : regionForVendorListing.name_declension_what;
    // in client some data arrives later than other, check if everything is there before constructing link
    if (!regionForVendorListing.slug || !label) {
        return null;
    }

    return {
        url: rpAppLink.vendor.listFriendly({
            friendlySlug: regionForVendorListing.slug
        }),
        label
    };
};

const getRegionDataForVendorListingLink = (
    region: IRegion,
    parentRegions: Omit<IRegion, "stats">[]
): {
    slug?: string;
    name: string;
    name_declension_what?: string;
} | null => {
    const useCityData = getShouldUseCityData(region.type);
    const parentRegion = parentRegions.find(({type}) => type === (useCityData ? RegionType.CITY : RegionType.VOIVODESHIP));

    if (parentRegion) {
        return parentRegion;
    }
    if (!parentRegion && region.stats?.region_type_city) {
        return region.stats?.region_type_city;
    }

    return null;
};

const getShouldUseCityData = (regionType: RegionType): boolean => [RegionType.DISTRICT, RegionType.NEIGHBORHOOD, RegionType.CITY].includes(regionType);
import {rpAppLink} from "@pg-mono/rp-routes";

import {RegionType} from "../../region/types/RegionType";

interface IRegion {
    name: string;
    short_name?: string;
    name_declension_what: string;
    slug: string;
    stats?: {
        region_type_city?: {
            slug?: string;
            name: string;
        } | null;
    } | null;
    type: RegionType;
}

type UrlReturnType = {
    url: string;
    label: string;
} | null;

export const getRegionDataForVendorListing = (region: IRegion, parentRegions: Omit<IRegion, "stats">[]): UrlReturnType => {
    // no region
    if (!region) {
        return null;
    }

    // voivodeship exception
    if (region.type === RegionType.VOIVODESHIP) {
        return {
            url: rpAppLink.vendor.listFriendly({
                friendlySlug: region.slug
            }),
            label: `z ${region.name_declension_what}`
        };
    }

    const regionForVendorListing = getRegionDataForVendorListingLink(region, parentRegions);
    if (!regionForVendorListing) {
        return null;
    }

    const label = getShouldUseCityData(region.type) ? regionForVendorListing.name : regionForVendorListing.name_declension_what;
    // in client some data arrives later than other, check if everything is there before constructing link
    if (!regionForVendorListing.slug || !label) {
        return null;
    }

    return {
        url: rpAppLink.vendor.listFriendly({
            friendlySlug: regionForVendorListing.slug
        }),
        label
    };
};

const getRegionDataForVendorListingLink = (
    region: IRegion,
    parentRegions: Omit<IRegion, "stats">[]
): {
    slug?: string;
    name: string;
    name_declension_what?: string;
} | null => {
    const useCityData = getShouldUseCityData(region.type);
    const parentRegion = parentRegions.find(({type}) => type === (useCityData ? RegionType.CITY : RegionType.VOIVODESHIP));

    if (parentRegion) {
        return parentRegion;
    }
    if (!parentRegion && region.stats?.region_type_city) {
        return region.stats?.region_type_city;
    }

    return null;
};

const getShouldUseCityData = (regionType: RegionType): boolean => [RegionType.DISTRICT, RegionType.NEIGHBORHOOD, RegionType.CITY].includes(regionType);
